import { createApp } from 'vue';
import App from './App.vue';
import router from './router';

// 1. Bibliothèques CSS Tierces (Chargées en premier)
import 'bootstrap/dist/css/bootstrap.min.css';
import 'animate.css';

// 2. CSS Personnalisé (Chargé en dernier pour avoir la priorité)
import './assets/custom-styles.css';

// 3. Plugins
import 'lazysizes';

const app = createApp(App);

// 4. Configuration des performances
if (process.env.NODE_ENV !== 'production') {
  app.config.performance = true;
}

// 5. Gestion Globale des Erreurs
app.config.errorHandler = (err, instance, info) => {
  const componentName = instance?.$options?.name || 'Composant Inconnu';
  console.error(`[Erreur Vue] - Composant: ${componentName} | Contexte: ${info}`);
  console.error(err);
};

// 6. Désactivation des avertissements en production
if (process.env.NODE_ENV === 'production') {
  app.config.warnHandler = () => null;
}

// 7. Initialisation standard et robuste
app.use(router);
app.mount('#app');